import { Link } from 'react-router-dom';
import { Scale, Mail, ArrowRight } from 'lucide-react';

const Footer = () => {
  const beliebteRatgeber = [
    { href: '/llc-usa-gruenden', label: 'LLC Gründung USA' },
    { href: '/ltd-uk-gruenden', label: 'LTD Gründung UK' },
    { href: '/registered-agent', label: 'Was ist ein Registered Agent?' },
    { href: '/ratgeber/llc-wyoming-gruenden', label: 'LLC in Wyoming gründen' },
    { href: '/ratgeber/ein-nummer-beantragen', label: 'EIN beantragen' },
    { href: '/northwest-registered-agent-erfahrungen', label: 'Northwest Testbericht' },
  ];

  const rechtlichesLinks = [
    { href: '/impressum', label: 'Impressum' },
    { href: '/datenschutz', label: 'Datenschutzerklärung' },
    { href: '/haftungsausschluss', label: 'Haftungsausschluss' },
    { href: '/affiliate-offenlegung', label: 'Affiliate-Offenlegung' },
    { href: '/nutzungsbedingungen', label: 'Nutzungsbedingungen' },
  ];

  return (
    <footer className="bg-navy-950 text-white" data-testid="footer">
      {/* CTA Bar */}
      <div className="bg-teal-600" data-testid="footer-cta-bar">
        <div className="container-wide py-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <div>
              <p className="text-white font-heading text-xl md:text-2xl font-bold">
                Bereit, Ihre Firma zu gründen?
              </p>
              <p className="text-teal-100 text-sm md:text-base mt-1">
                Starten Sie mit unserem Testsieger Northwest Registered Agent — ab $39 + Staatsgebühren.
              </p>
            </div>
            <a
              href="https://www.northwestregisteredagent.com"
              target="_blank"
              rel="nofollow sponsored noopener noreferrer"
              className="inline-flex items-center gap-2 px-6 py-3 bg-white text-teal-700 font-semibold rounded-sm hover:bg-teal-50 transition-colors whitespace-nowrap"
              data-testid="footer-cta-button"
            >
              Jetzt starten
              <ArrowRight className="w-4 h-4" />
            </a>
          </div>
        </div>
      </div>

      {/* Main Footer */}
      <div className="container-wide py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Column 1: About */}
          <div>
            <Link to="/" className="flex items-center gap-2 mb-6">
              <div className="flex items-center justify-center w-8 h-8 bg-teal-600 rounded-sm">
                <Scale className="w-5 h-5 text-white" />
              </div>
              <span className="font-heading font-bold text-xl text-white">
                ReviewLex<span className="text-slate-500 font-normal">.de</span>
              </span>
            </Link>
            <p className="text-slate-400 text-sm leading-relaxed mb-4">
              Ihr unabhängiger Ratgeber für Firmengründung weltweit. Wir testen und vergleichen 
              Gründungsdienstleister, damit Sie die beste Entscheidung für Ihr Unternehmen treffen können.
            </p>
            <p className="text-slate-500 text-xs">
              Stand: April 2026
            </p>
          </div>

          {/* Column 2: Beliebte Ratgeber */}
          <div>
            <h4 className="font-heading font-bold text-white mb-6">Beliebte Ratgeber</h4>
            <ul className="space-y-3">
              {beliebteRatgeber.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-slate-400 hover:text-teal-400 text-sm transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 3: Rechtliches */}
          <div>
            <h4 className="font-heading font-bold text-white mb-6">Rechtliches</h4>
            <ul className="space-y-3">
              {rechtlichesLinks.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-slate-400 hover:text-teal-400 text-sm transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 4: Kontakt */}
          <div>
            <h4 className="font-heading font-bold text-white mb-6">Kontakt</h4>
            <div className="space-y-4">
              <a
                href="mailto:kontakt@reviewlex.de"
                className="flex items-center gap-3 text-slate-400 hover:text-teal-400 text-sm transition-colors"
              >
                <Mail className="w-4 h-4" />
                kontakt@reviewlex.de
              </a>
              <Link
                to="/kontakt"
                className="inline-flex items-center gap-2 text-teal-400 hover:text-teal-300 text-sm font-medium transition-colors"
              >
                Kontaktformular
                <ArrowRight className="w-4 h-4" />
              </Link>
            </div>
            
            {/* Newsletter */}
            <div className="mt-8">
              <h5 className="font-heading font-semibold text-white text-sm mb-3">
                Newsletter
              </h5>
              <p className="text-slate-500 text-xs mb-3">
                Firmengründungs-Tipps direkt in Ihr Postfach
              </p>
              <div className="flex gap-2">
                <input
                  type="email"
                  placeholder="Ihre E-Mail"
                  className="flex-1 px-3 py-2 bg-navy-900 border border-navy-700 rounded-sm text-sm text-white placeholder-slate-500 focus:outline-none focus:border-teal-500"
                  data-testid="newsletter-input"
                />
                <button
                  className="px-4 py-2 bg-teal-600 text-white text-sm font-medium rounded-sm hover:bg-teal-700 transition-colors"
                  data-testid="newsletter-submit"
                >
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-navy-800">
        <div className="container-wide py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-slate-500">
            <p>© 2026 ReviewLex.de — Alle Rechte vorbehalten.</p>
            <p className="text-center md:text-right">
              <span className="text-slate-600">Affiliate-Hinweis:</span> Einige Links auf dieser Website 
              sind Affiliate-Links. <Link to="/affiliate-offenlegung" className="text-teal-500 hover:text-teal-400">Mehr erfahren</Link>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
